import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>Both of these studies show that while being honest and effective
                                                at delivering feedback might seem straightforward, there are
                                                still basic steps which can be missed out.</p>
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Giving feedback to people helps to provide honest, constructive
                                                advice. It is important that the recipient engages with the
                                                feedback for the right reasons; thus basing claims on actual
                                                behavioural evidence is essential. This tool is about <span
                                                    className="brown  brownbold"> how to give feedback </span> and
                                                will help you to give constructive feedback and recognise the
                                                potential responses in order to pitch your message at the
                                                appropriate level.</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">INTRODUCTION: GIVING FEEDBACK AND RECOGNITION</span>
                                            </div>

                                            <div className="border_subtitle">What is feedback and recognition?
                                            </div>
                                            <p>Giving feedback and recognition is about sharing your
                                                observations of someone with them to enable their self-awareness
                                                to grow. This can include giving informal feedback as a means of
                                                providing encouragement or addressing a specific incident that
                                                has occurred. It can also be in a more formal review or
                                                performance appraisal scenario. If feedback is to help people
                                                develop themselves and their performance, then it needs to be
                                                done in a way that gives them the confidence to make positive
                                                changes.</p>
                                            <div className="border_subtitle">Why is this important?</div>
                                            <p>It is important for your team’s development, job satisfaction
                                                and, ultimately, performance. Feedback increases self-awareness
                                                and, primarily, confirms knowledge about where personal
                                                strengths and weaknesses lie. When feedback is used to clarify
                                                expectations about work performance it can lead to increased
                                                motivation, which then goes on to boost engagement and output.
                                                Recognising good work is part and parcel of giving feedback and
                                                is one of the main factors contributing to happiness at work.
                                                Research shows that positive emotions lead to increased
                                                productivity, creativity and discretionary effort (effort beyond
                                                the call of duty).</p>
                                            <div className="border_subtitle">When should you give feedback?
                                            </div>
                                            <p>Informal feedback on a regular basis will lead to an open culture
                                                where learning is encouraged. In the case of giving feedback
                                                about a specific incident, it is important that it is timely and
                                                not too long after the event for maximum impact.</p>
                                            <p>Formal feedback on performance should be scheduled on a regular
                                                basis that suits both the feedback giver and receiver. </p>
                                            <div className="border_subtitle">Who will benefit from feedback?
                                            </div>
                                            <p>Those who you manage, those who you work alongside and those who
                                                manage you will all benefit from different forms of
                                                feedback.</p>
                                            <div className="border_subtitle">How do you give feedback?</div>
                                            <div className="paraspace1"><p>This short guide to giving feedback
                                                will show you how to:</p></div>
                                            <ul className="greenbullet-list">

                                                <li>Apply the model of Two-Way Feedback and Recognition</li>
                                                <li>Use an ‘appreciative inquiry’</li>
                                                <li className="list-bottom-pad">Give feedback to different kinds
                                                    of people.
                                                </li>
                                            </ul>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}